import { AxiosResponse } from 'axios';
import {
  FanguardApiContractsWatchlistWatchlistDetailModel,
  FanguardApiContractsWatchlistWatchlistSummaryModel,
} from 'src/api/generated';
import { useAppNavigation } from 'src/routes';

import { get, post, put, remove } from '@/api/api';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useMutationWithMessages } from './helpers';

const URI = 'watchlists';

const useGetLists = () => {
  return useQuery({
    queryKey: ['watchlists'],
    queryFn: async () => {
      const response = await get<FanguardApiContractsWatchlistWatchlistSummaryModel[]>({ uri: URI });
      return response.data;
    },
    // (this isn't working correctly - lists don't refresh when data is outdated)
    // 1 minute, need to think about how often to refresh
    // might be because of modal where its called is outside a component tree?
    // staleTime: 1000 * 60,
  });
};

export const getListOptions = (id?: string | null) => ({
  queryKey: ['watchlists', id],
  queryFn: () => get<FanguardApiContractsWatchlistWatchlistSummaryModel>({ uri: `${URI}/${id}` }),
});

const useGetList = (
  id?: string,
): UseQueryResult<AxiosResponse<FanguardApiContractsWatchlistWatchlistSummaryModel>, Error> => {
  return useQuery({ ...getListOptions(id!), enabled: !!id });
};

const useCreateList = () => {
  return useMutationWithMessages(
    (data: FanguardApiContractsWatchlistWatchlistDetailModel) =>
      post({ uri: `${URI}`, data: { name: data.name, context: 'accesscontrol' } }),
    {
      entityType: 'list',
      action: 'create',
      queryKeysToInvalidate: [URI],
    },
  );
};

const useUpdateList = (id?: string) => {
  return useMutationWithMessages(
    (data: FanguardApiContractsWatchlistWatchlistDetailModel) =>
      put({ uri: `${URI}/${id}`, data: { name: data.name } }),
    {
      entityType: 'list',
      action: 'update',
      queryKeysToInvalidate: [URI],
    },
  );
};

const useDeleteList = () => {
  const { navigateTo } = useAppNavigation();

  return useMutationWithMessages((id: string) => remove({ uri: `${URI}/${id}` }), {
    entityType: 'list',
    action: 'delete',
    queryKeysToInvalidate: [],
    onSuccess: () => {
      navigateTo.lists();
    },
    customErrorMessage: true,
  });
};

export { useCreateList, useDeleteList, useGetList, useGetLists, useUpdateList };
